import React from 'react'
import { View, ViewStyle } from 'react-native'
import { observer } from 'mobx-react-lite'
import { Instance } from 'mobx-state-tree'

import { GameQuestion } from '@trivie/core/src/models/game/GameQuestion'
import { GameChoice } from '@trivie/core/src/models/game/GameChoice'
import { Branding } from '@trivie/core/src/models/Branding'

import { Button } from '../button'
import { color } from '../../theme/color'
import { Choice } from './Choice'

interface ChoicesProps {
  question: Instance<typeof GameQuestion>
  choices: Instance<typeof GameChoice>[]
  branding: Instance<typeof Branding>
  style?: ViewStyle
  /** 'survey' disables correct/incorrect coloring (surveys are ungraded). */
  mode?: 'quiz' | 'survey'
}
export const Choices = observer((props: ChoicesProps) => {
  const { question, choices, branding, style, mode = 'quiz' } = props
  const survey = mode === 'survey'

  return (
    // Stop all pointer events once answered so a second tap can't register during the
    // slide-out transition. Styling (highlight colors) is unchanged.
    <View style={{ ...LIST, ...style }} pointerEvents={question.answered ? 'none' : 'auto'}>
      {choices.map((choice, index) => {
        // Quiz: reveal correctness once answered. Survey: highlight the picked
        // choice(s) with the accent color, no correct/incorrect coloring.
        const highlighted = survey ? Boolean(choice.selected) : Boolean(question.answered)
        const backgroundColor = survey
          ? choice.selected
            ? branding.accent_color
            : branding.quiz_background
          : question.answered
            ? choice.correct
              ? branding.correct_answer
              : branding.incorrect_answer
            : branding.quiz_background
        return (
          <Choice
            key={choice.id.toString()}
            mode={mode}
            highlighted={highlighted}
            question={question}
            dataSet={{ qat: `choice-id-${index}` }}
            choice={choice}
            textColor={highlighted ? color.white : branding.text_color}
            backgroundColor={backgroundColor}
            borderColor={branding.accent_color}
          />
        )
      })}
      {question.MCA ? (
        <Button
          style={{
            backgroundColor:
              !survey && question.answered
                ? question.answeredCorrectly
                  ? branding.correct_answer
                  : branding.incorrect_answer
                : branding.accent_color,
          }}
          textStyle={{ color: color.white }}
          fullWidth
          tx="Common.submit"
          onPress={() => {
            if (question.answered) {
              return
            }
            question.answer()
          }}
        />
      ) : null}
    </View>
  )
})

const LIST: ViewStyle = {
  maxWidth: 800,
  width: '100%',
  alignSelf: 'center',
  gap: 16,
  justifyContent: 'flex-end',
}
